export const exploreRouteNames = {
  explore: 'dashboard.explore',
  preferences: 'dashboard.explore-preferences',
  context: 'dashboard.explore-context',
  single: 'dashboard.log',
};
